var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAreaChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_area_chart",
    transform: "translate(184.09 181.813)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 32,
    height: 32,
    transform: "rotate(90 14.862 -166.952)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_area_chart-2",
    "data-name": "ico_area_chart",
    transform: "translate(1.84 1.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53999",
    "data-name": "Path 53999",
    d: "M447.8,366.834v2.216a.412.412,0,0,1-.412.412h-1.236L444.5,365.1Z",
    transform: "translate(-605.725 -525.112)",
    fill: "#019a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54000",
    "data-name": "Path 54000",
    d: "M89.852,250.73v10.645H67.912a.412.412,0,0,1-.412-.412v-2.216l10.471-8.017Z",
    transform: "translate(-249.43 -417.024)",
    fill: "#06c270"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54001",
    "data-name": "Path 54001",
    d: "M77.971,168.072c-2.566,4.32-5.481,8.017-10.471,8.017v-12.41a.413.413,0,0,1,.425-.412C72.657,163.389,75.479,165.554,77.971,168.072Z",
    transform: "translate(-249.43 -334.366)",
    fill: "#9665c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54002",
    "data-name": "Path 54002",
    d: "M391.09,8.076V29.035a15.454,15.454,0,0,1-1.648-.086L384.5,18.373,389.443,7.8a9.194,9.194,0,0,1,1.216-.133A.413.413,0,0,1,391.09,8.076Z",
    transform: "translate(-549.02 -187.313)",
    fill: "#06b1be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54003",
    "data-name": "Path 54003",
    d: "M270.041,10.1V31.251c-5.846-.629-8.574-4.59-11.881-7.931C261.468,17.751,264.2,11.147,270.041,10.1Z",
    transform: "translate(-429.619 -189.614)",
    fill: "#00cfde"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAreaChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_area_chart.20b4e079b94d75fb4c891d4f4a50c547.svg";